module.exports = __webpack_public_path__ + "static/img/quotes_banner.dc8ad93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quotes_banner.jpg
// module id = 6HHa
// module chunks = 3